// Central API instance exports with lazy-loaded singletons
import { getBasePath } from '../config/env';

// AI APIs
import { AIConfigurationApi, AIPromptApi, AIPromptPlaygroundApi } from './ai';
import { Configuration as AiConfiguration } from './ai/configuration';

// Benchmark APIs
import { BenchmarkApi } from './benchmark';
import { Configuration as BenchmarkConfiguration } from './benchmark/configuration';

// Country Codes APIs
import { CountryCodesApi } from './country-codes';
import { Configuration as CountryCodesConfiguration } from './country-codes/configuration';

// Position APIs
import { PositionApi, PositionFieldMappingApi } from './position';
import { Configuration as PositionConfiguration } from './position/configuration';

// SuccessFactors APIs
import { SuccessFactorsApi } from './successfactors';
import { Configuration as SuccessFactorsConfiguration } from './successfactors/configuration';

// Tasks APIs
import { TasksApi } from './tasks';
import { Configuration as TasksConfiguration } from './tasks/configuration';

// Job Classification APIs
import {
  CompetenciesApi,
  JobClassificationCodesApi,
  JobClassificationSkillMappingsApi,
  JobFamiliesApi,
  JobFamilyCompetencyMappingsApi,
  JobLevelsApi,
  SkillClustersApi,
  SkillLevelsApi,
  SkillsApi,
  SkillTypesApi,
} from './job-classification';
import { Configuration as JobClassificationConfiguration } from './job-classification/configuration';

// Base path and configurations
const basePath = getBasePath();

const aiConfiguration = new AiConfiguration({ basePath });
const benchmarkConfiguration = new BenchmarkConfiguration({ basePath });
const countryCodesConfiguration = new CountryCodesConfiguration({ basePath });
const positionConfiguration = new PositionConfiguration({ basePath });
const successFactorsConfiguration = new SuccessFactorsConfiguration({ basePath });
const tasksConfiguration = new TasksConfiguration({ basePath });
const jobClassificationConfiguration = new JobClassificationConfiguration({ basePath });

// Export API instances directly
export const aiConfigurationApi = new AIConfigurationApi(aiConfiguration);
export const aiPromptApi = new AIPromptApi(aiConfiguration);
export const aiPromptPlaygroundApi = new AIPromptPlaygroundApi(aiConfiguration);
export const benchmarkApi = new BenchmarkApi(benchmarkConfiguration);
export const countryCodesApi = new CountryCodesApi(countryCodesConfiguration);
export const positionApi = new PositionApi(positionConfiguration);
export const positionFieldMappingApi = new PositionFieldMappingApi(positionConfiguration);
export const successFactorsApi = new SuccessFactorsApi(successFactorsConfiguration);
export const tasksApi = new TasksApi(tasksConfiguration);
export const competenciesApi = new CompetenciesApi(jobClassificationConfiguration);
export const skillsApi = new SkillsApi(jobClassificationConfiguration);
export const jobLevelsApi = new JobLevelsApi(jobClassificationConfiguration);
export const jobClassificationCodesApi = new JobClassificationCodesApi(jobClassificationConfiguration);
export const jobFamiliesApi = new JobFamiliesApi(jobClassificationConfiguration);
export const skillTypesApi = new SkillTypesApi(jobClassificationConfiguration);
export const skillClustersApi = new SkillClustersApi(jobClassificationConfiguration);
export const skillLevelsApi = new SkillLevelsApi(jobClassificationConfiguration);
export const jobFamilyCompetencyMappingsApi = new JobFamilyCompetencyMappingsApi(jobClassificationConfiguration);
export const jobClassificationSkillMappingsApi = new JobClassificationSkillMappingsApi(jobClassificationConfiguration);
